import { defineComponent, h, VNodeChildren } from 'vue';

export const SlideLeftTransition = defineComponent({
  setup(_, context) {
    return function render() {
      return h('transition', {
        props: {
          name: 'slideInLeft',
          mode: 'out-in',
        },
      }, context.slots.default?.());
    };
  },
});

export function slideLeftTransition(children: VNodeChildren) {
  return h(SlideLeftTransition, children);
}
